import styled from "styled-components";

import { Link as LinkDefault } from "ds/Button";
import * as Sticker from "ds/Sticker";

export const StickerRoot = styled(Sticker.Root)`
  width: 100%;
  margin: 0 auto;
`;

export const ReduceStickerRoot = styled(StickerRoot)`
  display: grid;
  grid-template-columns: max-content 1fr max-content;
`;

export const PermissionsStickerRoot = styled(StickerRoot)`
  max-width: 1080px;
  margin: 40px auto 8px;
`;

export const NoResourceStickerRoot = styled(StickerRoot)`
  margin: 22px auto 40px auto;
  display: grid;
  grid-template-columns: max-content 1fr max-content;

  & > :nth-child(2) {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const Link = styled(LinkDefault)`
  font-size: 13px;
`;
